import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { FC, ReactNode } from 'react';
import { Styling } from '@/styling';
import { DialogProps } from '@/hooks/useDialog';
import { Box } from '@/components/layout/Box';
import { DangerButton } from '@/components/input/Button';
import { StandardCard } from '@/components/card/standard';

const DialogCard = styled(StandardCard)`
  border-top: 8px solid ${({ theme }) => theme.palette.warning.main};
  margin: 0;
  max-width: 500px;
`;

const TextSection = styled(Box).attrs(({ theme }) => ({
  direction: 'vertical',
  alignX: 'center',
  spacing: theme.spacing[2],
}))``;

const ButtonSection = styled(Box).attrs(({ theme }) => ({
  direction: 'vertical',
  alignX: 'center',
  spacing: theme.spacing[1],
}))`
  margin-top: ${Styling.spacing(4)};
`;

const Header = styled.h2`
  ${Styling.typography('h2')};
  color: ${({ theme }) => theme.palette.warning.main};
`;

const Text = styled.div`
  ${Styling.typography('body')};
  color: #888888; // TODO move to theme
`;

export type WarningDialogProps = {
  header: ReactNode;
  text: ReactNode;
  okText?: string;
  onOk?(): void;
} & DialogProps;

export const WarningDialog: FC<WarningDialogProps> = ({
  header,
  text,
  okText,
  onOk,
  onClose,
}) => {
  const { t } = useTranslation();

  const handleOk = () => {
    onOk?.();
    onClose?.();
  };

  return (
    <DialogCard>
      <TextSection>
        <Header>{header}</Header>
        <Text>{text}</Text>
      </TextSection>
      <ButtonSection>
        <DangerButton text={okText ?? t('common.ok')} onClick={handleOk} />
      </ButtonSection>
    </DialogCard>
  );
};
